export default "__VITE_ASSET__9Ot7BwnU__"